<template>
  <div class="welcome-page">
    <div class="yousound">
      <img class="logo" src="/static/images/nav_logo_primary.png" />
    </div>
    <div class="avatar">
      <img src="/static/images/welcome-avatar.svg" alt="avatar" />
    </div>
    <div class="details">
      <div class="username">Hey, {{ this.username }}!</div>
      <div class="message">
        YouSound will be launching soon. <br />
        In the meantime, you can invite friends to join the fun.
      </div>
      <button @click="copyLink()" class="invite-button">Invite your friends</button>
      <router-link :to="`/`" class="home-link">
        Back home
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
    };
  },
  mounted() {
    this.username = this.$route.query.username || "Guest";
  },
  methods: {
    copyLink() {
      const message = `Hi, ${this.username} is inviting you to visit https://yousound.com/`;
      navigator.clipboard.writeText(message);
      this.$store.dispatch("error/showSuccessToast", ["Invite Link has been copied"]);
    },
  },
};
</script>

<style lang="scss" src="./index.scss"></style>



// WEBPACK FOOTER //
// index.vue?1dccfc4d